var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLinkedinFooter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#75777B",
    d: "M26.9714 3.2H5.0228C4.0171 3.2 3.2 4.0284 3.2 5.0457v21.9085c0 1.0172.8172 1.8458 1.823 1.8458h21.9485c1.0057 0 1.8286-.8286 1.8286-1.8458V5.0457c0-1.0172-.8229-1.8458-1.8286-1.8458M10.9371 25.1428H7.1428V12.9257h3.8v12.2171zM9.04 11.2571c-1.2172 0-2.2-.9886-2.2-2.2s.9828-2.2 2.2-2.2c1.2114 0 2.2.9886 2.2 2.2 0 1.2171-.9829 2.2-2.2 2.2m16.12 13.8857h-3.7943V19.2c0-1.4172-.0286-3.24-1.9715-3.24-1.9771 0-2.28 1.5428-2.28 3.1371v6.0457H13.32V12.9257h3.64v1.6685h.0514c.5086-.96 1.7486-1.9714 3.5943-1.9714 3.84 0 4.5543 2.5314 4.5543 5.8229z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLinkedinFooter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/linkedin-footer.8fdce6401897e5eaa2fb0982cf86bedf.svg";